/** Browser locale; falls back to 'en' on environments without `navigator`. */
export function getBrowserLocale(): string {
  if (typeof navigator !== 'undefined' && navigator.language) {
    return navigator.language;
  }
  return 'en';
}
